export const prepareTitle = (title: string) => {
    title = title ?? "Marketplace";

    return title.length < 45 ? `${title} | Joinsteer` : title;
};
